import React from "react";

export const HomeSVGComponent = () => (
    <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.64706 1L0.999996 9V22H6.7647V15H12.5294V22H18.2941V9L9.64706 1Z"
            stroke="#242E35"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
